exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress{height:.4rem}.progress-bar.bar-status.bg-danger{margin-right:10px}", ""]);

// exports
